/**
 * CampUpdateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * CampUpdateReq
 */
export interface CampUpdateReq {
  /** 营地ID */
  id?: string
  /** 营地名称 */
  name?: string
  /** 营地简介 */
  bio?: string
  /** 段位层次(1-7) */
  rank_tier?: number
  /** 头像文件ID */
  avatar_id?: string
}

/**
 * CampUpdateReq Schema
 */
export const CampUpdateReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '营地ID',
      format: 'string',
      type: 'string',
      label: '营地ID',
    },
    name: {
      description: '营地名称',
      format: '*string',
      maxLength: 50,
      minLength: 1,
      type: 'string',
      label: '营地名称',
    },
    bio: {
      description: '营地简介',
      format: '*string',
      maxLength: 500,
      type: 'string',
      label: '营地简介',
    },
    rank_tier: {
      description: '段位层次(1-7)',
      format: '*int',
      maximum: 7,
      minimum: 1,
      type: 'integer',
      label: '段位层次',
    },
    avatar_id: {
      description: '头像文件ID',
      format: '*string',
      type: 'string',
      label: '头像文件ID',
    },
  },
  type: 'object',
}
